import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import Typography from '../../Typography'
import { routes } from '../../../routes'
import { currencyFormatter, pluralize } from '../../../utils/functions'
import classes from './CartItem.module.sass'
import DisplaySheet from './DisplaySheet'
import PreviewImage from '../../PreviewImage';
import styles from './CartItem.module.sass';

const SeniorCartItem = ({ editable, orderPackage, removeItem, key = 'seniors' }) => {
  const imageTypes = useMemo(() => ([
    ...new Set(orderPackage.sheets.map((sheet) => sheet.imageType)),
  ]), [orderPackage.sheets.map((sheet) => sheet.imageType && sheet.imageType.id)])

  const containerClasses = cn({
    [classes.container]: true,
    [classes.bottomBorder]: orderPackage.addonSheets.length === 0,
    [classes.grayBottomBorder]: orderPackage.addonSheets.length > 0,
  })

  return (
    <>
      <div className={containerClasses}>
        <div>
          <Typography weight="bold" classes={classes.packageName}>
            {orderPackage.apiOption.name.trim()}
            {editable && (
              <Link
                className={classes.link}
                to={orderPackage.package.multiple ? (
                  (orderPackage.package.useNewPackageBuilder ? routes.multiPoseEdit(orderPackage.id) : routes.multiPoseReview(orderPackage.id))
                ) : (
                  routes.seniorPortraitReview(orderPackage.id)
                )}
              >
                <Typography tag="span">Edit</Typography>
              </Link>
            )}
          </Typography>
          <div className={classes.holder}>
            {orderPackage.seniorImageId && orderPackage.sheets.length === 0 && orderPackage.addonSheets.length !== 0 && (
              <div className={styles.displaySheet}>
                <div style={{ position: 'relative' }}>
                  <img style={{ maxWidth: '100%', position: 'relative', zIndex: 1 }} src={orderPackage.seniorImage.imageUrl} alt="Preview" />
                  <div style={{ position: 'absolute', inset: 0, backgroundColor: '#ddd', maxHeight: '125px' }} />
                </div>
              </div>
            )}
            {orderPackage.sheets.length > 0 && orderPackage.sheets.some((sheet) => sheet.backgroundId) && <DisplaySheet orderPackage={orderPackage} />}
            {orderPackage.addonSheets.length > 0 && orderPackage.addonSheets.some((sheet) => sheet.backgroundId) && <DisplaySheet orderPackage={orderPackage} />}
            <ul className={cn(classes.imageTypeList, classes.seniorContentList)}>
              {imageTypes.filter((imageType) => !!imageType).map((imageType) => <li key={`${key}-${imageType.id}`}>{imageType.name}</li>)}
            </ul>
          </div>
        </div>
        <div className={classes.columnTwo}>
          {editable && (
            <Typography
              align="right"
              classes={classes.link}
              onClick={() => removeItem(orderPackage.id, 'orderPackage')}
            >
              Remove
            </Typography>
          )}
          <Typography align="right">{currencyFormatter(orderPackage.price)}</Typography>
          {orderPackage.extraPoses > 0 ? (
            <Typography align="right">
              +
              {pluralize('Additional Pose', orderPackage.extraPoses)}
              {' '}
              {currencyFormatter(orderPackage.extraPoses * orderPackage.apiOption.additionalPoseCharge)}
            </Typography>
          ) : null}
        </div>
      </div>
      {orderPackage.addonSheets.length > 0 && (
        <div className={cn(classes.addonsContainer, classes.bottomBorder)}>
          <Typography weight="bold">Addons</Typography>
          <ul className={classes.seniorContentList}>
            {orderPackage.addonSheets.map(({ id, addon }) => (
              <li key={id}>
                <Typography>
                  {addon.name}
                  <Typography
                    tag="span"
                    className={classes.link}
                    onClick={() => removeItem(id, 'addon-sheets')}
                  >
                    Remove
                  </Typography>
                </Typography>
                <Typography>{currencyFormatter(orderPackage.price === 0 ? (addon.priceWithout || addon.priceWith) : addon.priceWith)}</Typography>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}

SeniorCartItem.defaultProps = {
  editable: true,
}

SeniorCartItem.propTypes = {
  editable: PropTypes.bool,
  orderPackage: PropTypes.object.isRequired,
  removeItem: PropTypes.func.isRequired,
}

export default SeniorCartItem
